import React, { useEffect, useRef } from 'react';
import Mainservicespage from '../mainservicepage/Mainservicespage';
import Navbar from '../navbar/Navbar';
import WaveFooter from '../footer/Footer';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Development from '../development/Development';

function FinisherHeaderComponent() {
  const headerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = './finisher-header.min.js';
    script.async = true;
    script.onload = () => {
      if (window.FinisherHeader) {
        new window.FinisherHeader({
          count: 5,
          size: {
            min: 900,
            max: 1500,
            pulse: 0
          },
          speed: {
            x: {
              min: 0,
              max: 0.3
            },
            y: {
              min: 0,
              max: 0
            }
          },
          colors: {
            background: '#033f26',
            particles: ['#6be5ff', '#ff333d', '#ffde00']
          },
          blending: 'lighten',
          opacity: {
            center: 0.15,
            edge: 0.05
          },
          skew: -2,
          shapes: ['s'],
          element: headerRef.current // bind to this element
        });
      }
    };

    document.body.appendChild(script);
  }, []);

  return (
    <div
      className="header finisher-header"
      ref={headerRef}
      style={{ width: '100%', height: 'auto' }}
    >
        <Navbar/>
         <Mainservicespage/> 
        {/* <WaveFooter/> */}
      
    </div>
  );
}

export default FinisherHeaderComponent;
